import { render, staticRenderFns } from "./Rash.vue?vue&type=template&id=52dc53f6&scoped=true"
import script from "./Rash.vue?vue&type=script&lang=js"
export * from "./Rash.vue?vue&type=script&lang=js"
import style0 from "./Rash.vue?vue&type=style&index=0&id=52dc53f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dc53f6",
  null
  
)

export default component.exports